import React, { Fragment } from 'react';

import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';

// Components

import SummaryItem from '../SummaryItem';

// Utils

import { toUTCAndFormat } from '@utils/dates/date.utils';
import { NO_PRIOR_DATA, SSAP_MEDICAL_EMERGENCY_PROPS } from '@constants/ssap/miscellaneous/miscellaneous';


const MedicalEmergencyInfo = props => {

    const {
        idx,
        name,
        medicalEmergency,
        isMedicalEmergencyShown
    } = props;

    const getFormatted = (value, name = '') => {
        if(name.includes('date')) {
            return value === null ? NO_PRIOR_DATA : toUTCAndFormat(value, 'MM/DD/YYYY');
        } else {
            return value === null ? NO_PRIOR_DATA : value;
        }
    };

    if (!isMedicalEmergencyShown) {
        return null;
    }

    return (
        <Fragment>
            {
                Object.values(SSAP_MEDICAL_EMERGENCY_PROPS).map((item) => {
                    return (
                        medicalEmergency[item] !== null && <SummaryItem
                            category={`ssap.input.${item.includes('date') ? 'label' : 'legend'}.${item}`}
                            replacements={{ personName: normalizeNameOfPerson(name) }}
                            value={getFormatted(medicalEmergency[item], item)}
                            desc={[
                                [
                                    `taxHousehold.householdMember[${idx}].medicalEmergency.${item}`,
                                    getFormatted,
                                    [item]
                                ]
                            ]}
                            summaryItemId={item}
                        />
                    );
                })
            }
        </Fragment>
    );
};

export default MedicalEmergencyInfo;
